// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT

import { Component, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-data-table-footer',
  templateUrl: './data-table-footer.component.html',
  styleUrls: ['./data-table-footer.component.scss']
})
export class DataTableFooterComponent {
  @Input() rowCount: any;
  @Input() pageSize: any;
  @Input() curPage: any;
  @Input() offset: any;
  @Input() avoidDisabled = false;
  @Input() paginationPage: any;
  @Input() nextDisabled = false;
  @Input() backDisabled = false;
  @Input() displaySearch = true;

  @Output() offsetChange = new EventEmitter();
  @Output() paginationChange = new EventEmitter();
  @Output() searchValues = new EventEmitter();

  @ViewChild('searchInput') searchInput: ElementRef<any> | undefined;

  searchValue = '';
  resetInput = false;

  constructor() {}

  getSearch(search: string) {
    if (search) {
      this.searchValue = search;
      if (this.searchInput) {
        this.searchInput.nativeElement.focus();
      }
      this.searchValues.emit(search);
    }
  }

  eraseSearch() {
    this.searchValue = '';
    this.searchValues.emit(this.searchValue);
    this.resetInput = false;
  }

  focusFunction() {
    this.resetInput = true;
  }

  moveBack() {
    if (this.backDisabled) {
      return;
    }

    this.offsetChange.emit(this.offset - 1);
    this.paginationChange.emit(-1);
  }
  moveNext() {
    if (this.nextDisabled) {
      return;
    }

    this.offsetChange.emit(this.offset + 1);
    this.paginationChange.emit(1);
  }

  isBackDisabled() {
    if (this.avoidDisabled) {
      return false;
    }

    return this.pageSize * this.offset + 1 === 1;
  }

  isNextDisabled() {
    if (this.avoidDisabled) {
      return false;
    }

    return this.pageSize * this.curPage >= this.rowCount;
  }

  paginationText() {
    if (this.paginationPage > -1) {
      return this.pagerAjax();
    }

    return this.pagerNoAjax();
  }

  pagerAjax() {
    return `Showing ${this.paginationPage * this.pageSize + 1} - ${this.pageSize * this.paginationPage +
      +this.rowCount}`;
  }

  pagerNoAjax() {
    return `Showing ${this.pageSize * this.offset + 1}
        - ${this.pageSize * this.curPage > this.rowCount ? this.rowCount : this.pageSize * this.curPage}
        of ${this.rowCount}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/data-table/data-table-footer/data-table-footer.component.ts